// extracted by mini-css-extract-plugin
module.exports = {"root":"TickList_root__rYyaU","listItem":"TickList_listItem__ZMIks","tick":"TickList_tick__f9Ntn"};